import type { FC } from 'react';

import { ConfluenceProductCard } from './confluence-product-card';
import { JiraProductCard } from './jira-product-card';
import { JpdProductCard } from './jpd-product-card';
import { JsmProductCard } from './jsm-product-card';
import { ServiceCollectionProductCard } from './service-collection-product-card';
import { TeamworkCollectionProductCard } from './teamwork-collection-product-card';

import type { ProductKey } from '../../calculator/types';

export {
	ConfluenceProductCard,
	JiraProductCard,
	JpdProductCard,
	JsmProductCard,
	ServiceCollectionProductCard,
	TeamworkCollectionProductCard,
};

const PRODUCT_CARDS: Record<ProductKey, FC> = {
	jira: JiraProductCard,
	confluence: ConfluenceProductCard,
	jsm: JsmProductCard,
	jpd: JpdProductCard,
	teamworkCollection: TeamworkCollectionProductCard,
	serviceCollection: ServiceCollectionProductCard,
};

export interface ProductCardForKeyProps {
	productKey: ProductKey;
}

/** Renders the context-bound product card for a given product key. */
export const ProductCardForKey = (props: ProductCardForKeyProps) => {
	const Card = PRODUCT_CARDS[props.productKey];
	return <Card />;
};
